import { render, staticRenderFns } from "./PanelOptions.vue?vue&type=template&id=389f3a3d&scoped=true&"
import script from "./PanelOptions.vue?vue&type=script&lang=js&"
export * from "./PanelOptions.vue?vue&type=script&lang=js&"
import style0 from "./PanelOptions.vue?vue&type=style&index=0&id=389f3a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f3a3d",
  null
  
)

export default component.exports